export enum IncentivesVariations {
  cards = 'default-slice',
  twoCards = 'incentivesTwoCards',
  threeColumns = 'incentivesThreeColumns'
}
